




import { Component, Vue } from 'nuxt-property-decorator';
import KeyHandleEventBus from '@/store/keyHandle.eventbus';

@Component({
  components: {}
})
export default class GlobalKeyPressHandler extends Vue {
  mounted() {
    document.addEventListener('keyup', this.keyUpHandler);
  }

  keyUpHandler(ev: KeyboardEvent) {
    /// Html handlers are case-insensitive
    KeyHandleEventBus.$emit(ev.key.toLowerCase(), ev);
  }

  destroyed() {
    document.removeEventListener('keyup', this.keyUpHandler);
  }
}
